// src/app/data/navigation-constants.ts

import type { NavigationMetadata, NavigationCategory } from './navigation-types';

// Navigation configuration constants
export const NAVIGATION_VERSION = "2.2.0";
export const LAST_UPDATED = new Date().toISOString();

// Priority levels for category ordering
export const CATEGORY_PRIORITY: Record<string, number> = {
  "AI Tools": 1,
  "Media Tools": 2,
  "Learning/Guides": 3,
  "Productivity": 4,
  "Account & Auth": 5,
  "Generators": 6,
  "Text Tools": 7,
  "Developer Utilities": 8,
  "Security": 9,
  "Color Tools": 10,
  "Finance": 11,
  "Math & Calculations": 12,
  "Analytics": 13,
  "Resources": 14,
  "Troubleshooting": 15,
} as const;

// Navigation metadata - computed at build time for better performance
function computeNavigationMetadata(): NavigationMetadata {
  // This will be computed by a build script or at module load time
  return {
    totalLinks: 0, // Will be calculated after categories are defined
    categories: [], // Will be populated after categories are defined
    lastUpdated: LAST_UPDATED,
    version: NAVIGATION_VERSION,
  };
}

// Lazy initialization of navigation metadata
let _navigationMetadata: NavigationMetadata | null = null;

export function getNavigationMetadata(): NavigationMetadata {
  if (!_navigationMetadata) {
    _navigationMetadata = computeNavigationMetadata();
  }
  return _navigationMetadata;
}

// Legacy export for backward compatibility
export const navigationMetadata = getNavigationMetadata();
